import React, { useContext } from 'react';
import { makeStyles, Box, Link } from '@material-ui/core';
import ArrowBackwardIcon from '@material-ui/icons/ArrowBack';
import UButton from 'components/UButton';
import UPaper from 'components/UPaper';
import { getTenantFromLocalStorage } from 'api/tenant';
import { BrowserView, MobileView } from 'react-device-detect';
import { Alert } from '@material-ui/lab';
import { CONFIG } from 'constants/config';
import { ConsultaContext } from '../Context';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

function Display() {
  const {
    data, clear, loading, error,
  } = useContext(ConsultaContext);
  const classes = useStyles();
  const currentTenant = getTenantFromLocalStorage();
  const urlFile = `${CONFIG.api.replace('TENANT_ID', currentTenant)}/service-docs/v1/certificados/publico/documento/${data?.codigo}`;

  return !loading && data && !error && (
    <UPaper className={classes.root} fullWidth>
      <UButton
        gutterTop={false}
        type="button"
        variant="outlined"
        color="secondary"
        onClick={clear}
        startIcon={<ArrowBackwardIcon />}
      >
        Voltar
      </UButton>
      <Box p={1}>
        Resultado da Validação:
        {data.mensagem}
        {
          data.certificadoStatus === 'REEDITADO'
            ? (
              <div>
                <UButton
                  gutterTop={false}
                  type="button"
                  href={`/docs/validar/${data.codigoAtualizado}`}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="sm"
                >
                  Visualizar
                </UButton>
              </div>
            )
            : (
              <div>
                <BrowserView>
                  <embed
                    src={urlFile}
                    type="application/pdf"
                    width="100%"
                    height="500"
                    className={classes.pdf}
                  />
                </BrowserView>
                <MobileView>
                  <Alert className={classes.alert} severity="warning">
                    Atenção! Para visualizar corretamente os dados do certificado, clique no botão Download para baixar o arquivo
                    e utilize o programa
                    <Link href="https://adobeacrobat.app.link/"> Adobe Reader </Link>
                    para abri-lo.
                  </Alert>
                  <UButton
                    gutterTop={false}
                    type="button"
                    href={`
                      ${CONFIG.api.replace('TENANT_ID', currentTenant)}/service-docs/v1/certificados/publico/documento/${data?.codigo}`}
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Download
                  </UButton>
                </MobileView>
              </div>
            )
        }
      </Box>
    </UPaper>
  );
}

export default Display;
